module.exports = __webpack_public_path__ + "static/vishal-garg-200w-103018-234ec442f876784dd153bf4788cd5a8a.jpg";